import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { TemplatePermissionsResp } from '../interfaces/setup.interface';
import { ApiFacadeService } from './api-facade.service';
import { CacheService } from './cache.service';

@Injectable({
	providedIn: 'root',
})
export class SettingsService {
	constructor(private cache: CacheService, private apiFacade: ApiFacadeService) {}

	resendEmailConfirmation(email: string, white_label: string): Observable<any> {
		const url = 'auth2/resend-verify-email';
		return this.apiFacade.post(url, { email, white_label }).pipe(catchError((err) => throwError(err)));
	}

	getTemplateAndPermissionsMap(
		label: string,
		cloud = 'AWS',
		ignoreCache: boolean = false,
	): Observable<TemplatePermissionsResp> {
		const key = 'permissions-template';
		const url = 'frontend/account/get-template-permissions';

		if (!ignoreCache) {
			if (this.cache.get(key) != null) {
				return of(this.cache.get(key));
			}
		}

		return this.apiFacade
			.post<TemplatePermissionsResp>(url, { label, cloud })
			.pipe(tap((res) => this.cache.set(key, res)));
	}
}
